var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.componentStyle.comp,
    _vm._g(
      _vm._b(
        {
          tag: "component",
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        "component",
        { ..._vm.componentStyle.props },
        false
      ),
      _vm.componentStyle.on
    ),
    [
      _c(
        "v-card",
        {
          staticClass: "half-round safe-bottom",
          class: [
            { "mobile-scroll": _vm.$vuetify.breakpoint.xs && _vm.mobileScroll },
            _vm.color,
          ],
          staticStyle: { overflow: "auto" },
          attrs: {
            id: "soli-responsive-dialog",
            flat: "",
            light: _vm.theme == "light",
            dark: _vm.theme == "dark",
            "max-height": _vm.fullscreen ? "90vh" : _vm.size * 1.5,
          },
        },
        [
          _c(
            "v-container",
            {
              class: {
                "pt-0": !!_vm.title || _vm.$vuetify.breakpoint.xs,
                "pa-0": _vm.hideContainer,
              },
            },
            [
              _c(
                "div",
                [
                  _vm.close
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "ma-3 soli-close",
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              _vm.show = false
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("clear")])],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.title || _vm.$slots.title
                    ? _c(
                        "v-card-title",
                        {
                          class: [
                            _vm.theme == "light" ? "soli-grey" : "white--text",
                            ..._vm.titleClasses,
                          ],
                        },
                        [_vm._t("title"), _vm._v(_vm._s(_vm.title))],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.subtitle || _vm.$slots.subtitle
                    ? _c(
                        "v-card-subtitle",
                        { class: _vm.subtitleClasses },
                        [_vm._t("subtitle"), _vm._v(_vm._s(_vm.subtitle))],
                        2
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _vm._t("body"),
            ],
            2
          ),
          _vm._v(" "),
          _vm._t("cover"),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }